import { U21Button } from 'app/shared/u21-ui/components';
import { toggleTableConfigSidebar } from 'app/modules/sidebar/slice';
import { TableConfigType } from 'app/shared/CustomConfig/models';
import { IconLayoutColumns } from '@u21/tabler-icons';
import { useDispatch } from 'react-redux';

interface Props {
  tableConfigType: TableConfigType;
}

export const ChooseColumnsButton = (props: Props) => {
  const { tableConfigType } = props;
  const dispatch = useDispatch();
  return (
    <U21Button
      onClick={(e) => {
        dispatch(
          toggleTableConfigSidebar({
            coordinates: { x: e.clientX, y: e.clientY },
            tableConfigType,
          }),
        );
      }}
      startIcon={<IconLayoutColumns />}
    >
      Choose Columns
    </U21Button>
  );
};
